<app-icon
  [class]="{
    'icon__check-icon': valid(),
    'icon__exclamation-icon': !valid(),
  }"
  [icon]="valid() ? 'circle-check' : 'circle-exclamation'"
/>
